// Where a staff-entered order came from (Facebook message, Instagram DM, a
// call…). Saved as the order's attribution so Website Analytics can count
// these orders next to website orders. Same file in erp-thekseoul and rxk.
export const ORDER_SOURCES = [
  { value: 'fb-message', label: 'Facebook message', source: 'Facebook' },
  { value: 'ig-dm', label: 'Instagram DM', source: 'Instagram' },
  { value: 'whatsapp', label: 'WhatsApp', source: 'WhatsApp' },
  { value: 'call', label: 'Phone call', source: 'Phone call' },
  { value: 'fb-shop', label: 'Facebook shop', source: 'Facebook' },
  { value: 'walk-in', label: 'Walk-in / office', source: 'Walk-in' },
  { value: 'referral', label: 'Referral (friend, doctor…)', source: 'Referral' },
  { value: 'other', label: 'Other', source: 'Other' },
] as const;

export function orderSourceAttribution(value: string): { source: string; utm_medium: string; utm_content: string } | undefined {
  const s = ORDER_SOURCES.find((x) => x.value === value);
  return s ? { source: s.source, utm_medium: 'staff', utm_content: s.label } : undefined;
}
